<div
  *ngIf="showModal"
  id="loginModal-01"
  class="modal fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
  (click)="emitHideModal()"
>
  <div
    class="relative card_color rounded-lg max-w-md w-full flex flex-col md:flex-row text_white overflow-hidden shadow-lg mx-4 sm:mx-8 my-10 max-h-[90vh] overflow-y-auto"
    (click)="$event.stopPropagation()"
  >
    <!-- Botón de cierre -->
    <button
      class="close-modal absolute top-4 right-4 text_gray hover:text_white text-2xl font-bold"
      (click)="emitHideModal()"
    >
      &times;
    </button>

    <!-- Formulario de inicio de sesión -->
    <div
      class="w-full p-6 sm:p-8 flex flex-col justify-center card_color rounded-b-lg md:rounded-r-lg md:rounded-bl-none"
    >
      <div class="mb-4">
        <img
          [src]="logo ? logo : 'assets/images/no-photo-available.png'"
          alt="Logo"
          class="mx-auto object-contain"
          style="width: 200px; height: 60px"
        />
      </div>

      <h2 class="text-xl sm:text-2xl font-medium mb-4 sm:mb-6 text-left">
        Iniciar sesión
      </h2>
      <form class="space-y-4" [formGroup]="loginForm" (submit)="login()">
        <div class="relative">
          <label for="username" class="block mb-2 text-sm font-medium text_gray"
            >Nombre de usuario</label
          >
          <div class="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon icon-tabler icons-tabler-outline icon-tabler-user absolute left-3 text_color_customize"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
              <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
            </svg>
            <input
              formControlName="user"
              (focus)="clearToast()"
              autocomplete="off"
              type="text"
              class="text_white placeholder_gray_customize autofill:text_color_customize sm:text-sm border_line_customize rounded-lg focus_line_customize focus_line_blue_customize w-full pl-10 pr-10 p-3 bg_color"
              placeholder="nombre de usuario"
            />
          </div>
        </div>

        <div class="relative">
          <label
            for="loginPassword"
            class="block mb-2 text-sm font-medium text_gray"
            >Tu contraseña</label
          >
          <div class="flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon icon-tabler icons-tabler-outline icon-tabler-lock absolute left-3 text_color_customize"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z"
              />
              <path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" />
              <path d="M8 11v-4a4 4 0 1 1 8 0v4" />
            </svg>
            <input
              (keyup.enter)="login()"
              maxlength="16"
              formControlName="password"
              [type]="showPassword ? 'text' : 'password'"
              autocomplete="off"
              placeholder="••••••••"
              class="text_white placeholder_gray_customize autofill:text_color_customize sm:text-sm border_line_customize rounded-lg focus_line_customize focus_line_blue_customize w-full pl-10 pr-10 p-3 bg_color"
            />
            <button
              type="button"
              class="absolute right-3 flex items-center cursor-pointer"
              (click)="togglePasswordVisibility()"
            >
              <!-- 👁️ functionality-->
              <i
                [ngClass]="showPassword ? 'pi-eye' : 'pi-eye-slash'"
                class="pi icon icon-tabler icon-tabler-eye-off w-5 h-5 text_color_customize"
              ></i>
            </button>
          </div>
        </div>

        <div class="flex items-center justify-between">
          <label class="flex items-center text-sm text_gray">
            <input
              formControlName="keepMeSigned"
              type="checkbox"
              class="mr-2 w-5 h-5 rounded text_gray focus:ring-0"
            />
            Recordarme
          </label>
          <span
            (click)="showResetPassword()"
            class="cursor-pointer text-sm hover:underline"
            >¿Olvidaste tu contraseña?</span
          >
        </div>

        <button
          type="button"
          (click)="login()"
          [disabled]="loginForm.invalid"
          class="w-full my-2 block py-3 font-normal text-center text_white hover:text_black button_color_customize hover:button_color_customize font-medium rounded-lg"
          [class.pointer-events-none]="loginForm.invalid"
        >
          <div class="inline-flex items-center">Iniciar sesión</div>
        </button>

        <div class="text-center mt-4 text-sm text_gray">
          ¿No tienes cuenta?
          <span
            (click)="emmitNoAccount()"
            class="cursor-pointer text_color_customize hover:underline"
            >Crear Cuenta</span
          >
        </div>

        <div
          class="text-xs text-center"
          [ngStyle]="{ color: cardColor, margin: 0 }"
        >
          {{ version }}
        </div>
      </form>
    </div>
  </div>
</div>
<app-recover-password-modal
  [showModal]="showRecoveryPasswordModal"
  (hideModal)="showRecoveryPasswordModal = false"
></app-recover-password-modal>
<app-restore-password-component
  [showModal]="showResetPasswordModal"
  (hideModal)="onHideResetPasswordModal()"
></app-restore-password-component>
